import { parseJwtPayload, toUrlParameters } from './util';
export class TokenRemoteRepository {
    constructor(fetcher, contextId, tokenSessionStorageRepository) {
        this.fetcher = fetcher;
        this.contextId = contextId;
        this.tokenSessionStorageRepository = tokenSessionStorageRepository;
    }
    async createRegisteredUserToken(credentials, locale) {
        const params = {
            contextId: this.contextId,
            locale: locale,
            grant_type: 'password',
            username: credentials.username,
            password: credentials.password,
        };
        return await this.createToken(params);
    }
    async createClientUserToken(credentials, locale) {
        const params = {
            contextId: this.contextId,
            locale: locale,
            grant_type: 'anonymous',
            sessionUsername: credentials.username
        };
        return await this.createToken(params);
    }
    async createToken(params) {
        const jwt = await this.fetcher.fetchPostJson(TokenRemoteRepository.TOKEN_PATH, toUrlParameters(params), { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' });
        this.tokenSessionStorageRepository.setToken(jwt.access_token);
        return parseJwtPayload(jwt.access_token);
    }
    deleteToken() {
        this.tokenSessionStorageRepository.clearToken();
    }
}
TokenRemoteRepository.TOKEN_PATH = '/oauth/token';
